import { useQuery } from '@tanstack/react-query';
import { api } from 'constants/api';
import { AudienceFiltersBrazeObject } from 'types/create-campaign';

import { ApiResponse } from 'types/utils/api-response';

export type CampaignAnalytics = {
  id: number;
  campaign: {
    name: string;
    scheduled: string;
  };
  audience: {
    audience_name: string;
    audience_filters: AudienceFiltersBrazeObject;
    audience_stores: {
      id: number;
      name: string;
    }[];
  };
  channel: 'sms' | 'push';
  messages_sent: number | null;
  unique_recipients: number | null;
  conversion_rate: number | null;
  total_revenue: number | null;
  current_audience: number | null;
  sends: number | null;
  sends_to_carrier: number | null;
  confirmed_deliveries: number | null;
  delivery_failures: number | null;
  rejections: number | null;
  opt_out: number | null;
  help: number | null;
  revenue: number | null;
  primary_conversions: number | null;
  clicked: number | null;
  open: number | null;
};

export type CampaignAnalyticsResponseType = CampaignAnalytics;

export const useGetCampaignAnalyticsById = (params?: {
  campaignId: string;
}) => {
  const { campaignId } = params || {};
  return useQuery({
    queryKey: ['useGetCampaignAnalyticsById', campaignId],
    enabled: Boolean(params),
    queryFn: async () => {
      const { data } = await api.get<
        ApiResponse<CampaignAnalyticsResponseType>
      >(`campaign/analytics/${campaignId}`);

      return data.data;
    },
  });
};
